import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';
import { toggleAlertModal } from '../../../redux/actions/alertActions';
export const toolsDriverObj = (dispatch) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.addTools',
        popover: {
          title: 'Add New Tools',
          description:
            'Click here to add new tools. These tools can be used to enhance alert system capabilities and streamline workflows.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.toolMapping',
        popover: {
          title: 'Map Tools to Customers through STN Tenant',
          description:
            'This section allows you to map tools to customers by a specific id within the STN Tenant, ensuring that each customer has the correct resources assigned.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.toolProjects',
        popover: {
          title: 'Manage Tool-Project Associations',
          description:
            'Here, you can manage the associations between tools and projects, helping to maintain effective resource allocation across your projects.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.customerToolMapping',
        popover: {
          title: 'Map Tools to Customers through Customer Tenant',
          description:
            'This section allows you to map tools to customers by the Customer Tenant, ensuring that each customer has the correct resources assigned.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.customerToolMappingTable',
        popover: {
          title: 'Manage Tool Customer Tenants',
          description:
            'This section allows you to manage the associated Customer Tenants for each tool.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.toolMainTable',
        popover: {
          title: 'Tools Overview',
          description:
            'This table provides an overview of all the tools available in the system. You can add, edit, or delete tools as necessary to keep your toolset up to date.',
          side: 'left',
          align: 'start',
          onNextClick: () => {
            dispatch(toggleAlertModal());
            driverObj.destroy();
          },
        },
      },
    ],
  });
  return driverObj;
};
export default toolsDriverObj;
